/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filter_CollapseInputs */

const vi_common_filter_collapse = /** @type {(inputs: Common_Filter_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu gọn bộ lọc`)
};

/**

* @param {Common_Filter_CollapseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_filter_collapse = /** @type {((inputs?: Common_Filter_CollapseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_CollapseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_filter_collapse(inputs)
});